import { Shift } from "../apis/types";

const actions = {
  SET_ALL_SHIFT: "SET_ALL_SHIFT",
  SET_SUSPICIOUS_SHIFTS: "SET_SUSPICIOUS_SHIFTS",

  setShifts: (data: Shift[]) => ({
    type: actions.SET_ALL_SHIFT,
    payload: data,
  }),

  setSuspiciousShifts: (data: Shift[]) => ({
    type: actions.SET_SUSPICIOUS_SHIFTS,
    payload: data,
  }),
};
export default actions;
